export default {
    CityName: 'Middelkoop'
}